import "jquery";
import Swal from "sweetalert2";

import { referenceElement } from "./applicationDynamicElem";

$(function () {
  $("#browse-files").on("click", function (e) {
    e.preventDefault();
    console.log("called");
    $("#upload-docs").trigger("click");
  });
  $("#upload-docs").on("change", function (e) {
    const file = e.target.files[0];
    if (file) {
      if (file.type === "application/pdf") {
        $(".upload-doc-file-name").html(file.name);
        $(".doc-file-upload").removeClass("error");
        $(".doc-file-error").addClass("hidden");
      } else {
        Swal.fire({
          title: "Error",
          text: `Please upload pdf file.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    }
  });
  $("#browse-resource").on("click", function (e) {
    e.preventDefault();
    console.log("called");
    $("#upload-research").trigger("click");
  });
  $("#upload-research").on("change", function (e) {
    const file = e.target.files[0];
    if (file) {
      if (file.type === "application/pdf") {
        $(".upload-research-file-name").html(file.name);
        $(".research-file-upload").removeClass("error");
        $(".research-error").addClass("hidden");
      } else {
        Swal.fire({
          title: "Error",
          text: `Please upload pdf file.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    }
  });
  $("#more-reference").click(addNewReference);
  $(".reference-details-list").on(
    "click",
    ".remove-reference-details",
    removeReferenceDetails
  );
  $(".reference-details-list").on(
    "change",
    handleReferenceData
  );
  $(".reference-details-list").on("keypress", ".numberonlyField", checkNumberKey);
  $(".textonlyField").on("keypress", checkNumberInTextKey);
  $(".reference-details-list").on(
    "cut copy paste",
    ".numberonlyField",
    function (e) {
      e.preventDefault();
    }
  );
  $("#intern_application_form").on("submit", validateFile);
});

function addNewReference(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  $(".reference-details-list").append(referenceElement());
  handleReferenceData(e);
}

function removeReferenceDetails(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  const id = $(this).parent().parent().find("input.reference_id").val() || "";
  const url = $(this).attr("href");
  const message = "Are you sure you want to remove the added reference?";
  getExpConfirmation(message, (result) => {
    if (result.isConfirmed) {
      $(this).parent().parent().remove();
      handleReferenceData(e);
    }
  });
}

function getExpConfirmation(text, callback) {
  Swal.fire({
    title: "Warning",
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "No, keep it",
  }).then(callback);
}

function handleReferenceData(e) {
  const references = [];
  $(".reference-details-item").each(function (e) {
    const obj = {};
    obj["id"] = $(this).find("input.reference_id").val() || "";
    obj["name"] = $(this).find("input.name").val() || "";
    obj["relationship"] = $(this).find("input.relationship").val() || "";
    obj["email"] = $(this).find("input.email").val() || "";
    obj["phone"] = $(this).find("input.phone").val() || "";
    references.push(obj);
  });
  $("#references").val(JSON.stringify(references));
  if (references.length === 4) $("#more-reference").addClass("hidden");
  else $("#more-reference").removeClass("hidden");
}

function checkNumberKey(e) {
  var charCode = e.which ? e.which : e.keyCode;
  if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  } else {
    return true;
  }
}

function checkNumberInTextKey(e) {
  const charCode = e.which ? e.which : e.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return true;
  } else {
    return false;
  }
}

function validateFile() {
  const file = $("#upload-docs").prop("files")[0];
  const resFile = $("#upload-research").prop("files")[0];
  if (!file) {
    $(".doc-file-upload").addClass("error");
    $(".doc-file-error").removeClass("hidden");
    return false;
  }
  if (!resFile) {
    $(".research-file-upload").addClass("error");
    $(".research-error").removeClass("hidden");
    return false;
  }
};
